import React from "react";
import "./DashboardLayout.css";

const DashboardLayout = ({ children }) => {
  // Expect children: [<Sidebar />, <PageComponent />]
  const sidebar = React.Children.toArray(children).find(
    child => child && child.type && child.type.name === "Sidebar"
  );
  const content = React.Children.toArray(children).filter(
    child => !(child && child.type && child.type.name === "Sidebar")
  );
  return (
    <div className="dashboard-layout">
      <div className="dashboard-layout__sidebar">{sidebar}</div>
      <div className="dashboard-layout__content">{content}</div>
    </div>
  );
};

export default DashboardLayout;
